import styled from 'styled-components';
import { fadeIn } from '../../shared';

/* ===============================
   Existing Styles
   =============================== */

const LoadingDotsWrapper = styled.div`
  align-self: center;
  text-align: center;
  display: block;
  vertical-align: middle;

  > div {
    align-self: center;
    text-align: center;
    vertical-align: middle;
  }

  > div > div {
    width: 0.93em;
    height: 0.93em;
    opacity: 0.375;
    vertical-align: middle;
  }
`;

const StyledNoContent = styled.div`
  text-align: center;
  font-size: 1.225em;
  color: #b5bbc1;
`;

const StyledModalBodyRow = styled.div`
  padding-bottom: 0.75rem;
  margin-left: 0;
  margin-right: 0;
  padding-top: 0.75rem;
  background-clip: border-box;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.075);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0;
  animation: ${fadeIn} 0.3s both ease-in-out;
`;

/* ===============================
   Notification Modal Styles
   =============================== */

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;

const Modal = styled.div`
  background-color: #fff;
  max-width: 540px;
  width: 100%;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.35);
`;

const Title = styled.h2`
  margin-top: 0;
`;

const Body = styled.div`
  margin-bottom: 20px;
  white-space: pre-wrap;
`;

const Controls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
`;

const Button = styled.button`
  padding: 8px 18px;
  cursor: pointer;
`;

/* ===============================
   Exports
   =============================== */

export {
  LoadingDotsWrapper,
  StyledNoContent,
  StyledModalBodyRow,
  Overlay,
  Modal,
  Title,
  Body,
  Controls,
  CheckboxLabel,
  Button,
};
